import { action, observable } from 'mobx';

import { DynamicForm } from '@app/src/common/components/dynamic-form';
import notificationService from '@app/src/services/notification-service/NotificationService';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';

import { forgotPasswordFormConfig } from '../components/ForgotPasswordFormFields';

export class ForgotPasswordFormStore {
  @observable loading: boolean = false;
  @observable isSend: boolean = false;

  form = new DynamicForm(forgotPasswordFormConfig);

  @action
  sendToken = async () => {
    this.loading = true;
    try {
      await UserManagementRepository.sendResetPasswordLetter(
        this.form.email.value
      );
      this.isSend = true;
      notificationService.successMessage('notification.reset-password.success');
    } catch (error) {
      notificationService.errorMessage('notification.reset-password.error');
    } finally {
      this.loading = false;
    }
  };
}

export default ForgotPasswordFormStore;
